import InsuranceServicePresetOption from './insurance';
import ConfirmationPresetOption from './confirmation';
import PackageTypePresetOption from './package-type';
import ShippingServicePresetOption from './shipping-service';
import SizeInchesPresetOption from './size-inches';
import WeightPresetOption from './weight/index';
import ShipFromPresetOption from './ship-from/index';
import { warehouseId, shippingService, packageTypeId, confirmationId, insuranceProviderId, weight, dimensions } from '../constants';

const presetOptionComponents = {
  [warehouseId]: ShipFromPresetOption,
  [shippingService]: ShippingServicePresetOption,
  [packageTypeId]: PackageTypePresetOption,
  [confirmationId]: ConfirmationPresetOption,
  [insuranceProviderId]: InsuranceServicePresetOption,
  [weight]: WeightPresetOption,
  [dimensions]: SizeInchesPresetOption,
};

export default presetOptionComponents;
